<header class="proc__header">
  <div class="container">
    <ng-container *ngIf="isMobile">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <ngb-alert [type]="'light'" *ngIf="!isClose" (close)="alertClose()">
              <div class="clearfix mobile-alert">
                <img [src]="'assets/img/ic_launcher.png'" alt="-">
                <a routerLink="/gvp/application">Мобильное приложение "Органы военной прокуратуры"</a>
              </div>
            </ngb-alert>
          </div>
        </div>
    </ng-container>
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="proc__flex proc__flex__space-beetwen">
          <div class="proc__btn-link--m-auto proc__header__group--button flex" id="regionMenuButton" style="margin-left: 0">
            <app-site-vp-selector></app-site-vp-selector>
          </div>
          <a class="gl-btn proc__btn-link proc__vertical__middle proc__send-recourse" routerLink="/{{selectedVpo?.code}}/reception">
            <i class="icon icon__massege  margin-icon--right"></i>
            <span>Подать обращение</span>
          </a>
          <a class="bvi-open gl-btn proc__btn-link proc__vertical__middle proc__send-recourse" style="padding-left: 15px">
            <i class="fa fa-eye" aria-hidden="true" style="font-size: 1.3em"></i>
            <span style="padding-left: 10px">Версия для слабовидящих</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</header>

<section class="proc__header-sticky" style="padding: 10px 0 10px 0">
  <div class="container">
    <div class="row row--flex row--v-center">
      <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
        <a routerLink="/{{selectedVpo?.code}}">
          <div class="proc__logo">
            <img [src]="'assets/img/logo_gp.svg'" alt="logo">
            <div class="proc__logo__text proc__logo__text--header">
               {{selectedVpo?.name}}
            </div>
          </div>
        </a>
      </div>
      <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12 ">
        <div class="proc__flex proc__flex--between proc__flex--v-align">
          <div>
            <nav class="proc__nav hidden-md hidden-xs hidden-sm mobile-hidden" style="/*padding-top: 30px*/">
              <a class="proc__nav__link" routerLink="/{{selectedVpo?.code}}/about">О ведомстве</a>
              <a class="proc__nav__link" routerLink="/{{selectedVpo?.code}}/events">Деятельность</a>
              <!-- a class="proc__nav__link" href="javascript:;">Документы</a -->
              <a class="proc__nav__link " routerLink="/{{selectedVpo?.code}}/staff">Кадры</a>
              <a class="proc__nav__link" routerLink="/{{selectedVpo?.code}}/contacts">Контакты</a>
              <a class="proc__nav__link" routerLink="/{{selectedVpo?.code}}/scammers" style="color: #ff586b; font-weight: 500">Осторожно! Мошенники!</a>
            </nav>
          </div>
          <div>
            <nav class="proc__nav hidden-md hidden-xs hidden-sm mobile-show" ngbDropdown placement="bottom-right">
              <button type="button" class="gl-btn btn-light gl-btn--flex" ngbDropdownToggle>
                <i class="icon icon__submenu"></i>
              </button>
              <div ngbDropdownMenu class="dropdown-menu" role="menu">
                <a class="dropdown-item" routerLink="/{{selectedVpo?.code}}/about">О ведомстве</a>
                <a class="dropdown-item" routerLink="/{{selectedVpo?.code}}/events">Деятельность</a>
                <a class="dropdown-item" routerLink="/{{selectedVpo?.code}}/documents">Документы</a>
                <a class="dropdown-item" routerLink="/{{selectedVpo?.code}}/staff">Кадры</a>
                <a class="dropdown-item" routerLink="/{{selectedVpo?.code}}/contacts">Контакты</a>
                <a class="dropdown-item" routerLink="/{{selectedVpo?.code}}/scammers" style="color: #ff586b; font-weight: 500">Осторожно! Мошенники!</a>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
